const TRANSLATION_ENDPOINT = '/business-api/message-translate.php';

export class MessageTranslationError extends Error {
  constructor(message, code = '') {
    super(message);
    this.name = 'MessageTranslationError';
    this.code = code;
  }
}

export async function translateMessage({ token, targetLanguage, message, context = [], signal }) {
  const response = await fetch(TRANSLATION_ENDPOINT, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ token, target_language: targetLanguage, message, context }),
    signal
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.ok === false) {
    throw new MessageTranslationError(
      payload.message || `AI 翻译请求失败 (${response.status})`,
      payload.errorCode || ''
    );
  }
  return payload.translation || {};
}

